<template>
  <div class="flex flex-col w-full">
    <!-- Mobile one card carousel -->
    <div class="md:hidden">
      <div
        v-for="(review, index) in reviews"
        :key="index"
        class="w-full"
        :class="{ hidden: index !== activeIndex }"
      >
        <transition name="fade">
          <vetster-carousel-review-card
            v-show="index === activeIndex"
            :hide-date="hideDate"
            :review="review"
          />
        </transition>
        <vetster-carousel-buttons
          class="mt-8 flex justify-center space-x-6"
          @next="nextSlide"
          @prev="prevSlide"
        />
      </div>
    </div>

    <!-- Tablet three card carousel -->
    <div class="relative hidden md:grid grid-cols-3 w-full -translate-x-8 min-[875px]:-translate-x-2">
      <vetster-carousel-review-card
        :hide-date="hideDate"
        :review="getPreviousReview"
        is-side-card
        class="hidden md:flex md:min-w-80 -translate-x-1/2"
      />
      <div
        v-for="(review, index) in reviews"
        :key="index"
        :class="{ hidden: index !== activeIndex }"
        class="md:min-w-80"
      >
        <transition name="fade">
          <vetster-carousel-review-card
            v-show="index === activeIndex"
            :hide-date="hideDate"
            :review="review"
          />
        </transition>
        <vetster-carousel-buttons
          class="mt-8 flex justify-center space-x-6"
          @next="nextSlide"
          @prev="prevSlide"
        />
      </div>
      <vetster-carousel-review-card
        :hide-date="hideDate"
        :review="getNextReview"
        is-side-card
        class="hidden md:flex md:min-w-80 translate-x-1/2"
      />
    </div>
  </div>
</template>

<script>
import VetsterCarouselButtons from '@/components/VetsterCarouselButtons';
import VetsterCarouselReviewCard from '@/components/VetsterCarouselReviewCard';
import { getAssetUrl } from '@/helpers/url';

export default {
  name: 'VetsterReviewsCarousel',

  components: {
    VetsterCarouselButtons,
    VetsterCarouselReviewCard,
  },

  props: {
    hideDate: {
      type: Boolean,
      default: false,
    },
    reviews: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      activeIndex: 0,
      autoSlideInterval: null,
    };
  },

  computed: {
    getPreviousReview() {
      const previousReviewIndex = (this.activeIndex - 1 + this.reviews.length) % this.reviews.length;

      return this.reviews[previousReviewIndex];
    },
    getNextReview() {
      const previousReviewIndex = (this.activeIndex + 1 + this.reviews.length) % this.reviews.length;

      return this.reviews[previousReviewIndex];
    },
  },

  mounted() {
    this.startAutoSlide();
  },

  beforeDestroy() {
    this.stopAutoSlide();
  },

  methods: {
    getAssetUrl,
    startAutoSlide() {
      this.autoSlideInterval = setInterval(this.nextSlide, 5000);
    },
    stopAutoSlide() {
      clearInterval(this.autoSlideInterval);
    },
    prevSlide() {
      this.stopAutoSlide();
      this.activeIndex = (this.activeIndex - 1 + this.reviews.length) % this.reviews.length;
      this.startAutoSlide();
    },
    nextSlide() {
      this.stopAutoSlide();
      this.activeIndex = (this.activeIndex + 1) % this.reviews.length;
      this.startAutoSlide();
    },
  },
};
</script>
